
import React, { useState } from 'react';
import logo from '../../assets/images/logo.png';
import {ReactComponent as DashboardIcon} from '../../components/svgs/dashboardicon.svg';
import { ReactComponent as OrdersIcon } from '../../components/svgs/ordersicon.svg';
import { ReactComponent as CustomersIcon } from '../../components/svgs/customersicon.svg';
import { ReactComponent as ServicesIcon } from '../../components/svgs/servicesIcon.svg';
import { ReactComponent as EmployeesIcon } from '../../components/svgs/employeesIcon.svg';
import { ReactComponent as ReportsIcon } from '../../components/svgs/reportsIcon.svg';
import { ReactComponent as SettingsIcon } from '../../components/svgs/settingsIcon.svg';
import { ReactComponent as LogoutIcon} from '../../components/svgs/logouticon.svg';
import {ReactComponent as DropdownIcon} from '../../components/svgs/dropdownIcon.svg';
import { ReactComponent as SalesIcon } from '../../components/svgs/padlockIconGrey.svg';
import { ReactComponent as GratuityIcon } from '../../components/svgs/padlockIconGrey.svg';
import { Link, useLocation } from 'react-router-dom';
import OwnerSidebarDropdownLayout from './OwnerSideBarDropdownLayout';


const OwnerSidebar = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const location = useLocation();

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const links = [
    { label: 'Dashboard', icon: DashboardIcon, href: '/owner/dashboard' },
    { label: 'Orders', icon: OrdersIcon, href: '/owner/orders' },
    { label: 'Customers', icon: CustomersIcon, href: '/owner/customers' },
    { label: 'Services', icon: ServicesIcon, href: '/owner/services' },
    { label: 'Employees', icon: EmployeesIcon, href: '/owner/employees' },
  
    { label: 'Reports', icon: ReportsIcon, href: '#', isDropdown: true },
    { label: 'Settings', icon: SettingsIcon, href: '/owner/settings' },
    // { label: 'Logout', icon: LogoutIcon, href: '/logout' },
    
  ];

  const dropdownLinks = [
    { label: 'Invoices', href: '/owner/reports/invoicing' },
    { label: 'Sales', icon: SalesIcon, href: '/owner/reports/sales' },
    { label: 'Gratuity', icon: GratuityIcon, href: '/owner/reports/gratuity' },
  ];

  return (
    <div className="manager-sidebar">
      <section className="manager-sidebar-dropdown-layout">
        <OwnerSidebarDropdownLayout userInitials={'RG'} userName={'Rachel Green'} role={'Owner'} />
      </section>
      <nav className="mt-10">
        <ul>
          {links.map((link, index) => (
            <li
              key={index}
              className={`${
                link.href === location.pathname || location.pathname.startsWith(link.href)
                  ? 'active'
                  : ''
              }`}
            >
              <Link
                to={link.href}
                onClick={link.isDropdown ? toggleDropdown : null}
                className={`manager-sidebar-link ${
                  link.href === location.pathname || location.pathname.startsWith(link.href)
                    ? 'active'
                    : ''
                }`}
              >
                <span className={`icon ${link.href === location.pathname ? 'active' : ''}`}>
                  <link.icon />
                </span>
                <span className="label">{link.label}</span>
                {link.isDropdown && (
                  <span className={`dropdown-icon ${isDropdownOpen ? 'open' : ''}`}>
                    <DropdownIcon />
                  </span>
                )}
              </Link>
              {link.isDropdown && isDropdownOpen && (
                <ul className="dropdown-menu">
                  {dropdownLinks.map((dropdownLink, dropdownIndex) => (
                    <li
                      key={dropdownIndex}
                      className={`${
                        location.pathname === dropdownLink.href ? 'active' : ''
                      }`}
                    >
                      <Link
                        to={dropdownLink.href}
                        className={`manager-sidebar-sublink ${
                          location.pathname === dropdownLink.href ? 'active' : ''
                        }`}
                      >
                        <span className="manager-sidebar-subtext">{dropdownLink.label}</span>
                        {/* {dropdownLink.icon && (
                          <span className="icon mt-2">
                            <dropdownLink.icon className="ml-10" />
                          </span>
                        )} */}
                      </Link>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
      </nav>
      <section className="mt-44">
        <div className="flex gap-6 mb-6 logout-label-section">
          <LogoutIcon />
          <Link to={'/logout'} className="logout-label">
            Logout
          </Link>
        </div>
        <div className="logo">
          <img src={logo} alt="laundry Squared Logo" className="site-logo" />
        </div>
      </section>
    </div>
  );
};

export default OwnerSidebar;